class invoiceController {
    constructor($translate, $state, cacheService, sharedService, authService) {
        'ngInject';
        this.name = 'invoice';
        this.$translate = $translate;
        this.$state = $state;
        this.IS_MOBILE = sharedService.IS_MOBILE;
        this.is_there_flash_message = false;
        let createInvoiceResponse;
        this.paddingDigits = 9;
        this.invoiceFileUrl = '?access_token=' + authService.getAccessToken();
        if (createInvoiceResponse = cacheService.get('createInvoiceResponse')) {
            this.createInvoiceResponse = createInvoiceResponse;
            this.is_there_flash_message = true;
            cacheService.delete('createInvoiceResponse');
        }
    }

    $onInit() {
        if(this.data.invoices.length === 0){
            this.$state.go('bookings.booking.invoice.request');
        }

        this.translations = this.$translate.instant([
            "your_created_invoices",
            "id_invoice",
            "date_invoice",
            "total_invoice",
            "actions_invoice",
            "create_new_invoice",
            "invoice_correctly_created",
            "something_went_wrong"
        ]);
    }
}

export default invoiceController;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/invoice/invoice.controller.js